import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  IconButton,
  Drawer,
  Typography,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import AgentWiseSummaryReportComponent from "./AgentWiseSummaryReport";
import AgentOverallPerformanceComponent from "./AgentOverallPerformance";
import axios from "axios";
import {
  AUDIT_AGENT_PERFORMANCE,
  AUDIT_CALLING_REPORT,
  GET_AUDIT_BY_MOBILE_NO,
  OUTGOING_CALL_REPORT,
} from "../../constants";
import CallerComponent from "../Dialer/callerComponent";
import FilterComponent from "./FilterComponent";
import { useLocation } from "react-router-dom";
import AuditFormComponent from "../Agent Dashboard/AuditFormComponent";
import ExistigDataShowComponent from "./ExistingDataShow";
import dayjs from "dayjs";
import CallDistributionByAgentComponent from "./CallDistributionByAgent";
import StatusWiseSummaryComponent from "./StatusWiseSummary";
import OutboundCallDistributionComponent from "./OutboundCallDistribution";

const buttonStyle = {
  border: "1px solid #fff",
  borderRadius: "4px",
  margin: "5px",
  width: "40px",
  height: "40px",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#097969",
  color: "#fff",
  transition: "background-color 0.3s, transform 0.2s",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
};

const hoverEffects = (e, isHovering) => {
  e.currentTarget.style.backgroundColor = isHovering ? "#0B9B73" : "#097969";
  e.currentTarget.style.transform = isHovering ? "scale(1.05)" : "scale(1)";
};

function AuditAgentDashboardComponent() {
  const today = dayjs().startOf("day");
  const [filters, setFilters] = useState({
    startDate: today.subtract(6, "day").format("YYYY-MM-DD"),
    endDate: today.format("YYYY-MM-DD"),
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterShow, setFilterShow] = useState(false);

  const location = useLocation();
  const { mobNo, lotNum, missedCallId } = location.state || {}; // Destructure the state 

  const [tableMobile, setTableMobile] = useState("");

  const [formOpen, setFormOpen] = useState(false);
  const [FormMobileNo, setFormMobileNo] = useState("");
  const [auditMobNum, setAuditMobNum] = useState("");
  const [auditLotNum, setAuditLotNum] = useState("");
  const [auditName, setAuditName] = useState("");
  const [auditZone, setAuditZone] = useState("");

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [alertTitle, setalertTitle] = useState("");

  const [callID, setCallID] = useState("");
  const [callType, setCallType] = useState("");

  const [missedCallID, setMissdeCalID] = useState("");

  useEffect(()=>{
    if(missedCallId){
      setMissdeCalID(missedCallId);
    }
  },[missedCallId]);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const empDetails = JSON.parse(localStorage.getItem("userData"));

  const [typeOfUser, setTypeOfUser] = useState("");

  // Fetch data from the API
  const fetchData = async () => {
    setLoading(true);
    try {
      const { startDate, endDate } = filters;

      const formattedStartDate =
        startDate == null || startDate === ""
          ? dayjs().subtract(6, "days").format("YYYY-MM-DD")
          : dayjs(startDate).format("YYYY-MM-DD");

      const formattedEndDate =
        endDate == null || endDate === ""
          ? dayjs().format("YYYY-MM-DD")
          : dayjs(endDate).format("YYYY-MM-DD");

      // Build query parameters dynamically
      const queryParams = new URLSearchParams();
      queryParams.append("startDate", formattedStartDate);
      queryParams.append("endDate", formattedEndDate);
      queryParams.append("agentName", empDetails.EmployeeName);

      const response = await axios.get(
        `${AUDIT_AGENT_PERFORMANCE}?${queryParams.toString()}`
      );
      setData(response.data.data);
      console.log(response.data.data);
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  const [callData, setCallData] = useState([]);
  const [metricData, setMetricData] = useState([]);

  const fetchIncomingCallStatistics = () => {
    const { startDate, endDate } = filters;

    const formattedStartDate =
      startDate == null || startDate === ""
        ? dayjs().subtract(6, "days").format("YYYY-MM-DD")
        : dayjs(startDate).format("YYYY-MM-DD");

    const formattedEndDate =
      endDate == null || endDate === ""
        ? dayjs().format("YYYY-MM-DD")
        : dayjs(endDate).format("YYYY-MM-DD");

    const queryParams = new URLSearchParams();
    queryParams.append("startDate", formattedStartDate);
    queryParams.append("endDate", formattedEndDate);
    queryParams.append("agentNumber", empDetails.EmployeePhone);

    axios
      .get(`${AUDIT_CALLING_REPORT}?${queryParams.toString()}`)
      .then((response) => {
        const { data } = response.data;
        setCallData(data.agents);
        setMetricData(data.summary.metrics);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const[totalCalls, setTotalCalls] = useState("");
  const [connectedStatistics, setConnectedStatistics] = useState(0);
  const [notConnectedStatistics, setNotConnectedStatistics] = useState(0);

  const fetchOutgoingCallStatistics = () => {
    const { startDate, endDate } = filters;

    const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");

    const queryParams = new URLSearchParams();
    queryParams.append("startDate", formattedStartDate);
    queryParams.append("endDate", formattedEndDate);
    queryParams.append("aPartyNo", empDetails.EmployeePhone);

    axios
      .get(`${OUTGOING_CALL_REPORT}?${queryParams.toString()}`)
      .then((response) => {
        setTotalCalls(response.data?.totalCalls);
        setConnectedStatistics(response.data?.connected?.totalCount || 0);

        setNotConnectedStatistics(response.data?.notConnected?.totalCount || 0);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [filtersLoaded1, setFiltersLoaded1] = useState(false); // Track if filters are loaded

  useEffect(() => {
    // Load filters from localStorage on page load
    const savedFilters = localStorage.getItem("dashboardfilters");

    if (savedFilters) {
      const loadedFilters = JSON.parse(savedFilters);

      // Check if the filters have changed compared to the initial state
      if (
        loadedFilters.startDate !== filters.startDate ||
        loadedFilters.endDate !== filters.endDate
      ) {
        setFilters(loadedFilters); // Only set the new filters if they are different
      }
    }

    // Set filtersLoaded to true after initial load to prevent premature API call
    setFiltersLoaded1(true);
  }, []); // This runs only once on initial load

  useEffect(() => {
    // Only fetch the data if filters are loaded and filters state has changed
    if (
      filtersLoaded1 &&
      JSON.stringify(filters) !==
        JSON.stringify({
          startDate: dayjs().subtract(6, "days").toDate(),
          endDate: dayjs().toDate(),
        })
    ) {
      fetchData(); // Fetch data if filters have changed
      // fetchIncomingCallStatistics();
      // fetchOutgoingCallStatistics();
    }
  }, [filters, filtersLoaded1]); // Re-fetch when filters change



  return (
    <>
      <Grid
        container
        spacing={2}
        style={{
          flexWrap: "wrap", // Allow components to wrap on smaller screens
        }}
      >
        {/* Conditional Content Based on formOpen */}
        {formOpen ? (
          <>
            {/* Existing Data Section */}
            <Grid
              item
              xs={12}
              sm={5}
              md={5}
              style={{
                flexGrow: 1, // Make this take up remaining space
              }}
            >
              <ExistigDataShowComponent
                FormMobileNo={FormMobileNo}
                setTypeOfUser={setTypeOfUser}
                setAuditLotNum={setAuditLotNum}
                setAuditName={setAuditName}
                setAuditZone={setAuditZone}
              />
            </Grid>

            {/* Audit Form Section */}
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              style={{
                flex: "1 1 350px", // Ensure AuditFormComponent has a minimum width
                minWidth: "300px", // Minimum width for responsiveness
              }}
            >
              <AuditFormComponent
                setFormOpen={setFormOpen}
                setOpenSnackbar={setOpenSnackbar}
                setSeverity={setSeverity}
                setMessage={setMessage}
                setalertTitle={setalertTitle}
                FormMobileNo={FormMobileNo}
                mobNum={auditMobNum}
                typeOfUser={typeOfUser}
                auditMobNum={auditMobNum}
                auditLotNum={auditLotNum}
                auditName={auditName}
                auditZone={auditZone}
                setAuditLotNum={setAuditLotNum}
                setAuditName={setAuditName}
                setAuditZone={setAuditZone}
                callID={callID}
                callType={callType}
              />
            </Grid>
          </>
        ) : (
          <>
            {/* Filter and Performance Section */}
            <Grid item xs={12} md={8}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "100%",
                  marginBottom: 1,
                }}
              >
                {filterShow && (
                  <FilterComponent
                    filters={filters}
                    setFilters={setFilters}
                    data={data}
                    setFilterShow={setFilterShow}
                  />
                )}

                <IconButton
                  onClick={() => setFilterShow((prev) => !prev)}
                  style={buttonStyle}
                  onMouseEnter={(e) => hoverEffects(e, true)}
                  onMouseLeave={(e) => hoverEffects(e, false)}
                >
                  <FilterListIcon />
                </IconButton>
              </Box>
              <AgentOverallPerformanceComponent data={data} filters={filters} />
            </Grid>

            {/* Agent Wise Summary Report Section */}
            <Grid item xs={12} md={8}>
              <AgentWiseSummaryReportComponent data={data} />
            </Grid>

            {/* <Grid item xs={12} md={8}>
              <CallDistributionByAgentComponent
                callStatistics={callData}
                metricData={metricData}
                filters={filters}
              />
            </Grid>

            <Grid item xs={12} md={8}>
              <OutboundCallDistributionComponent
                totalCalls={totalCalls}
                connectedStatistics={connectedStatistics}
                notConnectedStatistics={notConnectedStatistics}
                filters={filters}
              />
            </Grid> */}
          </>
        )}

        {/* Caller Component Section (Always Displayed) */}
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          style={{
            position: "fixed",
            // top: 0,
            right: 0,
            width: "300px", // Fixed width for CallerComponent
            // height: "100vh", // Full height of the viewport
            // overflowY: "auto",
            zIndex: 1000, // Ensure it appears on top of other content
          }}
        >
          <CallerComponent
            tableMobile={tableMobile}
            setFormOpen={setFormOpen}
            setFormMobileNo={setFormMobileNo}
            auditMobNo={mobNo}
            setAuditMobNum={setAuditMobNum}
            setOpenSnackbar={setOpenSnackbar}
            setSeverity={setSeverity}
            setMessage={setMessage}
            setCallID={setCallID}
            missedCallID={missedCallID}
            setCallType={setCallType}
          />
        </Grid>
      </Grid>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default AuditAgentDashboardComponent;
